import { CgMathMinus } from "react-icons/cg"; 
import React from 'react';
import img from '../assets/a-photo-of-a-large-natural-diamond-resting-on-a-be-TuW1f56tTpuNsKFM72DITA-D0eTMBCHSfmWu-uKzmo1yA.jpeg';
import './header.css';

const Header = () => {
  return (
    <div className="relative w-full h-[400px] md:h-[600px]">
      <img src={img} alt="Natural Diamond and Stone" className="w-full h-full object-cover" />

      {/* Overlay for dark effect */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      {/* Main text with staggered animation */}
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center space-y-3">
        <h1 className="text-white text-4xl md:text-6xl font-bold uppercase tracking-wide">
          <span className="word-animation inline-block">Natural </span>
          <span className="word-animation md:inline-block pt-2 hidden ">-</span>
          <span className="word-animation inline-block">Diamond</span> 
          <span className="word-animation md:inline-block hidden">&</span>
          <span className="word-animation md:inline-block hidden">Natural <span> </span></span>
          <span className="word-animation md:inline-block hidden pt-2">-</span>
          <span className="word-animation inline-block md:hidden pt-2">&</span>
          <span className="word-animation inline-block">Stone</span>
        </h1>
        <p className="text-white text-lg md:text-2xl mt-4 font-medium opacity-0 animate-fade-in-2">
          Purity Guaranteed, Elegance Delivered
        </p>
        <p className="text-white text-lg md:text-2xl mt-2 opacity-0 animate-fade-in-3">
          Crafted with <span className="font-semibold">Care</span> &amp; <span className="font-semibold">Precision</span>
        </p>
      </div>
    </div>
  );
};

export default Header;
